// Redacts auth material before analytics or Sentry see URLs: tokens sit in the fragment, the PKCE code in the query.

const SENSITIVE_URL_PARAMS = [
  'access_token',
  'refresh_token',
  'provider_token',
  'provider_refresh_token',
  'id_token',
  'code',
  'token',
  'token_hash',
]

// Unparseable URLs are dropped, never guessed at.
export function redactUrl(raw: string): string {
  try {
    const url = new URL(raw)
    url.hash = ''
    for (const key of SENSITIVE_URL_PARAMS) {
      if (url.searchParams.has(key)) url.searchParams.set(key, 'REDACTED')
    }
    return url.toString()
  } catch {
    return ''
  }
}
